import React, { useState, useEffect } from 'react';
import '../styles/contact.css';
import {
    FaMapMarkerAlt,
    FaPhone,
    FaEnvelope,
    FaClock,
    FaWhatsapp,
    FaFacebook,
    FaInstagram,
    FaTwitter,
    FaLinkedin,
    FaUser,
    FaBuilding,
    FaCheckCircle,
    FaBars,
    FaTimes,
    FaArrowRight,
    FaPaperPlane,
    FaUserTie,
    FaUserFriends,
    FaHome,
    FaBath,
    FaBed
} from 'react-icons/fa';


import {
    FaUsers,
    FaCalendarAlt,
    FaFacebookF,
    FaLinkedinIn,
} from 'react-icons/fa';


import logo from "../images/logo.png";
import white_logo from "../images/white_logo.png";
import EnquiryForm from './EnquiryForm';

const Contact = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [scrolled, setScrolled] = useState(false);
    const [showEnquiryForm, setShowEnquiryForm] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitSuccess, setSubmitSuccess] = useState(false);

    // Handle scroll effect
    useEffect(() => {
        const handleScroll = () => {
            setScrolled(window.scrollY > 100);
        };
        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    // Handle mobile menu toggle
    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
        document.body.style.overflow = !mobileMenuOpen ? 'hidden' : 'auto';
    };

    // Close mobile menu when clicking on a link
    const handleNavLinkClick = () => {
        setMobileMenuOpen(false);
        document.body.style.overflow = 'auto';
    };

    const handleEnquireNow = (e) => {
        e.preventDefault();
        setShowEnquiryForm(true);
    };

    return (
        <div className="contact-page">
            {/* Header */}
            <header className={`main-header ${scrolled ? 'scrolled' : ''}`}>
                <div className="container header-container">
                    <div className="logo-container">
                        <img src={logo} alt="Logo" style={{ width: 50, height: 50 }} />
                        <div className="logo-text">
                            <h1>Shree Krishna Tiles</h1>
                        </div>
                    </div>

                    <button
                        className="mobile-menu-btn"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle menu"
                    >
                        {mobileMenuOpen ? <FaTimes /> : <FaBars />}
                    </button>

                    <nav className={`main-nav ${mobileMenuOpen ? 'active' : ''}`}>
                        <ul>
                            <li><a href="/" onClick={handleNavLinkClick}>Home</a></li>
                            <li><a href="/products" onClick={handleNavLinkClick}>Products</a></li>
                            <li><a href="#about" onClick={handleNavLinkClick}>About Us</a></li>
                            <li><a href="#testimonials" onClick={handleNavLinkClick}>Testimonials</a></li>
                            <li><a href="#blog" onClick={handleNavLinkClick}>Blog</a></li>
                            <li><a href="#" className="active" onClick={handleNavLinkClick}>Contact</a></li>
                        </ul>
                    </nav>
                </div>
            </header>

            {/* Mobile Menu Overlay */}
            {mobileMenuOpen && (
                <div
                    className="mobile-menu-overlay"
                    onClick={toggleMobileMenu}
                />
            )}

            {/* Enquire Now Button - Fixed Position */}
            <button className="enquire-now-btn" onClick={handleEnquireNow}>
                <span>Enquire Now</span>
                <FaArrowRight className="arrow-icon" />
            </button>

            {/* Main Content */}
            <main className="contact-main">
                <div className="container">
                    {/* Page Header */}
                    <div className="contact-page-header">
                        <h1>Get In Touch</h1>
                        <p>We're here to help you find the perfect tiles for your space</p>
                    </div>

                    {/* Contact Info Cards */}
                    <div className="contact-info-section">
                        <div className="contact-info-grid">
                            <div className="contact-info-card">
                                <div className="contact-info-icon phone">
                                    <FaPhone />
                                </div>
                                <h3>Call Us</h3>
                                <p>+91 99421 69120</p>
                                <button className="contact-action-btn">
                                    <FaPhone /> Call Now
                                </button>
                            </div>

                            <div className="contact-info-card">
                                <div className="contact-info-icon whatsapp">
                                    <FaWhatsapp />
                                </div>
                                <h3>WhatsApp</h3>
                                <p>+91 99421 69120</p>
                                <button className="contact-action-btn">
                                    <FaWhatsapp /> Message on WhatsApp
                                </button>
                            </div>

                            <div className="contact-info-card">
                                <div className="contact-info-icon email">
                                    <FaEnvelope />
                                </div>
                                <h3>Email Us</h3>
                                <p>info@shreekrishnatiles.co.in</p>
                                <button className="contact-action-btn">
                                    <FaEnvelope /> Send Email
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Contact Form and Map Section */}
                    <div className="contact-form-map-section">
                        {/* Contact Form */}
                        <div className="contact-form-container">
                            <div className="form-header">
                                <p className="form-eyebrow">GET IN TOUCH</p>
                                <h1 className="form-title">Send Us a Message</h1>
                                <p className="form-subtitle">We'll get back to you as soon as possible</p>
                            </div>

                            <form className="contact-form">
                                <div className="input-group">
                                    <label>Your Name*</label>
                                    <input
                                        type="text"
                                        name="name"
                                        placeholder=""
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Email*</label>
                                    <input
                                        type="email"
                                        name="email"
                                        placeholder=""
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Phone Number*</label>
                                    <input
                                        type="tel"
                                        name="phone"
                                        placeholder=""
                                        required
                                    />
                                </div>

                                <div className="input-group">
                                    <label>Subject</label>
                                    <input
                                        type="text"
                                        name="subject"
                                        placeholder=""
                                    />
                                </div>


                                <div className="input-group">
                                    <label>Your Message*</label>
                                    <textarea
                                        name="message"
                                        rows="4"
                                        placeholder=""
                                        required
                                    ></textarea>
                                </div>

                                <button type="submit" className="submit-btn">
                                    SEND MESSAGE
                                </button>
                            </form>
                        </div>

                        {/* Enquiry Form Modal */}
                        <EnquiryForm
                            isOpen={showEnquiryForm}
                            onClose={() => setShowEnquiryForm(false)}
                        />

                        {/* Map Section */}
                        <div className="map-container">
                            <div className="map-header">
                                <h2>Our Showroom Location</h2>
                                <p>Visit our showroom to explore our tile collection in person</p>
                            </div>

                            <div className="map-wrapper">
                                {/* Embedded Google Map */}
                                <iframe
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1385.823137997312!2d77.51889964204597!3d10.757607197174156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba9bf0059edfe2d%3A0xf87418e16013e0a2!2sShree%20Krishna%20Tiles!5e0!3m2!1sen!2sin!4v1766689296600!5m2!1sen!2sin"
                                    width="100%"
                                    height="400"
                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    title="Shree Krishna Tiles Showroom Location"
                                    referrerPolicy="no-referrer-when-downgrade"
                                ></iframe>
                            </div>

                            <div className="location-details">
                                <div className="location-info">
                                    <div className="location-icon">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div className="location-text">
                                        <h4>Shree Krishna Tiles Showroom</h4>
                                        <p>4/486, Sungam, Nanjiyampalayam, Dharapuram, Tiruppur 638657</p>
                                    </div>
                                </div>

                                <div className="location-info">
                                    <div className="location-icon">
                                        <FaClock />
                                    </div>
                                    <div className="location-text">
                                        <h4>Opening Hours</h4>
                                        <p>Monday - Saturday: 9:30 AM - 8:30 PM, Sunday: 10:00 AM - 6:00 PM</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Why Choose Us Section */}
                    <div className="why-choose-section">
                        <div className="section-header">
                            <h1>Why Choose Shree Krishna Tiles?</h1>
                            <p>Experience the difference with our premium tile solutions</p>
                        </div>

                        <div className="benefits-grid">
                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <FaCheckCircle />
                                </div>
                                <h3>Wide Selection</h3>
                                <p>Extensive collection of tiles for every room, style, and budget</p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <FaCheckCircle />
                                </div>
                                <h3>Expert Guidance</h3>
                                <p>Professional advice from experienced tile consultants</p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <FaCheckCircle />
                                </div>
                                <h3>Quality Assurance</h3>
                                <p>Premium quality tiles with manufacturer warranties</p>
                            </div>

                            <div className="benefit-card">
                                <div className="benefit-icon">
                                    <FaCheckCircle />
                                </div>
                                <h3>Free Consultation</h3>
                                <p>Complimentary design consultation for your project</p>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            {/* Footer */}
            <footer id="contact" className="main-footer">
                <div className="container">
                    <div className="footer-grid">
                        <div className="footer-col">
                            <div className="logo-container">
                                <img src={white_logo} alt="SKT Logo" width="60" height="60" />
                                <div>
                                    <h3>Shree Krishna Tiles</h3>
                                    <p>Premium Tiles Since 2001</p>
                                </div>
                            </div>
                            <p>
                                Your trusted partner for premium quality tiles.
                                We provide the finest ceramic, porcelain, vitrified,
                                and natural stone tiles for residential and commercial spaces.
                            </p>

                            <div className="social-links">
                                <a href="#" className="social-link"><FaFacebookF /></a>
                                <a href="#" className="social-link"><FaInstagram /></a>
                                <a href="#" className="social-link"><FaTwitter /></a>
                                <a href="#" className="social-link"><FaLinkedinIn /></a>
                            </div>
                        </div>

                        <div className="footer-col">
                            <h3>Quick Links</h3>
                            <ul className="quick-links">
                                <li><a href="/" onClick={(e) => handleNavLinkClick(e, '/')}><FaHome /> Home</a></li>
                                <li><a href="/products" onClick={(e) => handleNavLinkClick(e, '/products')}><FaBath /> Products</a></li>
                                <li><a href="/#categories" onClick={(e) => handleNavLinkClick(e, '/#categories')}><FaBed /> Categories</a></li>
                                <li><a href="/#about" onClick={(e) => handleNavLinkClick(e, '/#about')}><FaBuilding /> About Us</a></li>
                                <li><a href="/#testimonials" onClick={(e) => handleNavLinkClick(e, '/#testimonials')}><FaUsers /> Testimonials</a></li>
                                <li><a href="/blog" onClick={(e) => handleNavLinkClick(e, '/blog')}><FaCalendarAlt /> Blog</a></li>
                            </ul>
                        </div>

                        <div className="footer-col">
                            <h3>Contact Info</h3>
                            <ul className="contact-info">
                                <li>
                                    <div className="contact-icon">
                                        <FaMapMarkerAlt />
                                    </div>
                                    <div>
                                        <strong>Showroom Address</strong>
                                        <p>4/486, Sungam, Nanjiyampalayam<br />Dharapuram, Tiruppur 638657</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-icon">
                                        <FaPhone />
                                    </div>
                                    <div>
                                        <strong>Phone Number</strong>
                                        <p>+91 99421 69120</p>
                                    </div>
                                </li>
                                <li>
                                    <div className="contact-icon">
                                        <FaEnvelope />
                                    </div>
                                    <div>
                                        <strong>Email Address</strong>
                                        <p>info@shreekrishnatiles.co.in</p>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div className="footer-bottom">
                        <p>&copy; {new Date().getFullYear()} Shree Krishna Tiles. All rights reserved.</p>
                        <p>Made with ❤️ by <a href="https://theternos.github.io/portfolio/" target="_blank"> Ternos</a></p>
                    </div>
                </div>
            </footer>
            <EnquiryForm
                isOpen={showEnquiryForm}
                onClose={() => setShowEnquiryForm(false)}
            />
        </div>
    );
};

export default Contact;